import Backbone from "backboneAdapter";
import Handlebars from "handlebars";
import i18n from "l10n";
import Template from "templates/password.recover.hbs";
let template = Handlebars.compile(Template);

var PassRecoverView = Backbone.View.extend({
    el: '#page-main-content',
    events: {
        "keydown .input-control": "keypress",
        "click #submit-btn": "recover",
        "keydown input#emailInput": 'checkmail'
    },
    initialize: function () {
        this.render();
        this.setElement($('.grid'));
        this.$('[data-i18n]').i18n();
        console.info('Initializing Password Recover View');
    },
    render() {
        this.$el.html(template);
    },
    async recover(event) {
        event.preventDefault(); // Don't let this button submit the form
        $('.alert-error').hide(); // Hide any errors on a new submit
        var url = '/CampaignCloud/PassReset/Recover';
        console.info('Sending mail...');
        var formValues = {
            email: $('#emailInput').val()
        };

        console.info(formValues);
        $('#submit-btn').attr('disabled', true);
        $("#spinner").show();
        try {
            const recoverPassResponse = await $.ajaxDefaultQ({
                url: url,
                type: 'POST',
                dataType: "json",
                data: formValues
            });
            let $error = $("#error-message");
            if (recoverPassResponse.status === "success") {
                $error.addClass("fg-green");
                $error.removeClass("fg-red");
                $error.text(i18n.t("passwordrecover.checkmail"));
                $('#submit-btn').attr('disabled', true);
                $('#emailInput').attr('disabled', true);
                $("#spinner").hide();
            } else if (recoverPassResponse.message === "noUser") {
                $error.addClass("fg-red");
                $error.removeClass("fg-green");
                $error.text(i18n.t("passwordrecover.nousererror"));
                $("#submit-btn").removeAttr("disabled");
                $("#spinner").hide();
            } else {
                $error.addClass("fg-red");
                $error.removeClass("fg-green");
                $error.text(i18n.t("passwordrecover.internalerror"));
                $("#submit-btn").removeAttr("disabled");
                $("#spinner").hide();
            }
        } catch (e) {
            if (e.status === 401) {
                let $error = $("#error-message");
                $error.addClass("fg-red");
                $error.removeClass("fg-green");
                $error.text(i18n.t("passwordrecover.internalerror"));
                $("#submit-btn").removeAttr("disabled");
                $("#spinner").hide();
            }
        }
    },
    keypress: function (e) {
        var key = e.which;
        if (key === 13 && !$("#submit-btn").is(':disabled')) {
            $('input[id=submit-btn]').click();
            return false;
        }
    },
    checkmail: function () {
        $('#emailInput').on('input', function () {
            var $emailInput = $('#emailInput');
            var email = $emailInput.val();
            var re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i;
            $("#email-error-message").empty();
            if (!email.length || !re.test(email)) {
                $emailInput.removeClass('required-input');
                $emailInput.removeClass('valid-input');
                $emailInput.addClass('invalid-input');
                $emailInput.addClass('confirm-failure-input-borders');
                $('#submit-btn').attr('disabled', true);
            } else {
                $emailInput.removeClass('required-input');
                $emailInput.removeClass('invalid-input');
                $emailInput.removeClass('confirm-failure-input-borders');
                $emailInput.addClass('valid-input');
                $("#submit-btn").removeAttr("disabled");
            }
        });
    }
});

export {PassRecoverView as default};